//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('prePayment', {
//        templateUrl: 'views/components/views/prePayment/prePayment.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'translateService', 'modalService', 'prePaymentService', function ($stateParams, stateService, translateService, modalService, prePaymentService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let argType = $stateParams.argtype;
//            let argValue = $stateParams.argvalue;
//            let prePaymentKeyno = $stateParams.prepayment_keyno;

//            let translations = {
//                confirm_title: '',
//                confirm_message: '',
//                confirm_ok_label: '',
//                confirm_cancel_label: '',
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                invoiceButtons: [
//                    { id: 'goto', icon: 'fa fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('invoicehead', { invoice_no: vm.model.edit.invoice_no }) }
//                ],
//            	edit: {},
//                selectListCashTypePayments: [],
//                selectListPaymentPlans: [],
//                lockedCreateInvoice: false,
//                lockedSave: false,
//                lockedDelete: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATION FUNCTION

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATION FUNCTION

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadEdit() {
//                vm.model.edit = (await prePaymentService.getPrepayment({
//                    argtype: argType,
//                    argvalue: argValue,
//                    prepayment_keyno: prePaymentKeyno
//                }))[0];
//            }

//            async function loadCashTypePayments() {
//                vm.model.selectListCashTypePayments = await prePaymentService.listCashTypePayments();
//            }

//            async function loadPaymentPlans() {
//                vm.model.selectListPaymentPlans = await prePaymentService.listPaymentPlans(vm.model.edit);
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region BUTTON CREATE PROCEDURE FUNCTION CALL

//            vm.createChanges = function () {
//                vm.model.lockedCreateInvoice = true;

//                prePaymentService.createObj(vm.model.edit).then(function (response) {
//                    if (response[0].errorcode !== '0') {
//                    	modalService.show({
//                    		type: 'warning',
//                            title: translations.error,
//                    		message: response[0].errormessage,
//                    		buttons: [{
//                                label: translations.ok,
//                    			cssClass: 'btn-warning',
//                    			action: function (dialogItself) {
//                    				dialogItself.close();
//                    				vm.model.lockedCreateInvoice = false;
//                    			}
//                    		}]
//                    	});
//                    } else {
//                        vm.model.lockedCreateInvoice = false;
//                        loadEdit();
//                    }
//                });
//            }

//            // #endregion BUTTON CREATE PROCEDURE FUNCTION CALL

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;
//                vm.model.edit.argtype = argType;
//                vm.model.edit.argvalue = argValue;

//                prePaymentService.saveObj(vm.model.edit).then(() => {
//                    vm.model.lockedSave = false;
//                    stateService.back();
//                }, () => vm.model.lockedSave = false);
//            }

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region BUTTON DELETE PROCEDURE FUNCTION CALL

//            vm.deleteValues = function () {
//                vm.model.lockedDelete = true;

//                modalService.confirm({
//                    type: 'danger',
//                    title: translations.confirm_title,
//                    message: translations.confirm_message,
//                    okLabel: translations.confirm_ok_label,
//                    cancelLabel: translations.confirm_cancel_label
//                }).then(() => {
//                    prePaymentService.deleteItem({ prepayment_keyno: vm.model.edit.prepayment_keyno }).then(() => {
//                        vm.model.lockedDelete = false;
//                        stateService.back();
//                    }, () => vm.model.lockedDelete = false);
//                }, () => vm.model.lockedDelete = false);
//            }

//            // #endregion BUTTON DELETE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                translate();
//                await loadEdit();
//                loadCashTypePayments();
//                loadPaymentPlans();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
